import EmphasizedSection from "./EmphasizedSection";

export default EmphasizedSection;
